import { maxSpacingValue as m, minSpacingValue as n } from "../../theme/spacing.js";
import { isBetweenInclusive as c } from "../isBetweenInclusive/index.js";
import '../../assets/index35.css';const a = "_m0_oats3_2", r = "_m1_oats3_5", l = "_m2_oats3_8", b = "_m3_oats3_11", e = "_m4_oats3_14", i = "_m5_oats3_17", u = "_m6_oats3_20", f = "_m7_oats3_23", g = "_m8_oats3_26", S = "_m9_oats3_29", y = "_m10_oats3_32", v = "_mt0_oats3_40", x = "_mt1_oats3_43", C = "_mt2_oats3_46", V = "_mt3_oats3_49", $ = "_mt4_oats3_52", j = "_mt5_oats3_55", k = "_mt6_oats3_58", w = "_mt7_oats3_61", B = "_mt8_oats3_64", I = "_mt9_oats3_67", K = "_mt10_oats3_70", d = "_mr0_oats3_78", h = "_mr1_oats3_81", q = "_mr2_oats3_84", z = "_mr3_oats3_87", A = "_mr4_oats3_90", D = "_mr5_oats3_93", E = "_mr6_oats3_96", F = "_mr7_oats3_99", G = "_mr8_oats3_102", H = "_mr9_oats3_105", J = "_mr10_oats3_108", L = "_mb0_oats3_116", M = "_mb1_oats3_119", N = "_mb2_oats3_122", O = "_mb3_oats3_125", P = "_mb4_oats3_128", Q = "_mb5_oats3_131", R = "_mb6_oats3_134", T = "_mb7_oats3_137", U = "_mb8_oats3_140", W = "_mb9_oats3_143", X = "_mb10_oats3_146", Y = "_ml0_oats3_154", Z = "_ml1_oats3_157", __ = "_ml2_oats3_160", t_ = "_ml3_oats3_163", o_ = "_ml4_oats3_166", s_ = "_ml5_oats3_169", p_ = "_ml6_oats3_172", m_ = "_ml7_oats3_175", n_ = "_ml8_oats3_178", c_ = "_ml9_oats3_181", a_ = "_ml10_oats3_184", r_ = "_p0_oats3_189", l_ = "_p1_oats3_192", b_ = "_p2_oats3_195", e_ = "_p3_oats3_198", i_ = "_p4_oats3_201", u_ = "_p5_oats3_204", f_ = "_p6_oats3_207", g_ = "_p7_oats3_210", S_ = "_p8_oats3_213", y_ = "_p9_oats3_216", v_ = "_p10_oats3_219", x_ = "_pt0_oats3_227", C_ = "_pt1_oats3_230", V_ = "_pt2_oats3_233", $_ = "_pt3_oats3_236", j_ = "_pt4_oats3_239", k_ = "_pt5_oats3_242", w_ = "_pt6_oats3_245", B_ = "_pt7_oats3_248", I_ = "_pt8_oats3_251", K_ = "_pt9_oats3_254", d_ = "_pt10_oats3_257", h_ = "_pr0_oats3_265", q_ = "_pr1_oats3_268", z_ = "_pr2_oats3_271", A_ = "_pr3_oats3_274", D_ = "_pr4_oats3_277", E_ = "_pr5_oats3_280", F_ = "_pr6_oats3_283", G_ = "_pr7_oats3_286", H_ = "_pr8_oats3_289", J_ = "_pr9_oats3_292", L_ = "_pr10_oats3_295", M_ = "_pb0_oats3_303", N_ = "_pb1_oats3_306", O_ = "_pb2_oats3_309", P_ = "_pb3_oats3_312", Q_ = "_pb4_oats3_315", R_ = "_pb5_oats3_318", T_ = "_pb6_oats3_321", U_ = "_pb7_oats3_324", W_ = "_pb8_oats3_327", X_ = "_pb9_oats3_330", Y_ = "_pb10_oats3_333", Z_ = "_pl0_oats3_341", _t = "_pl1_oats3_344", tt = "_pl2_oats3_347", ot = "_pl3_oats3_350", st = "_pl4_oats3_353", pt = "_pl5_oats3_356", mt = "_pl6_oats3_359", nt = "_pl7_oats3_362", ct = "_pl8_oats3_365", at = "_pl9_oats3_368", rt = "_pl10_oats3_371", lt = {
  m0: a,
  m1: r,
  m2: l,
  m3: b,
  m4: e,
  m5: i,
  m6: u,
  m7: f,
  m8: g,
  m9: S,
  m10: y,
  mt0: v,
  mt1: x,
  mt2: C,
  mt3: V,
  mt4: $,
  mt5: j,
  mt6: k,
  mt7: w,
  mt8: B,
  mt9: I,
  mt10: K,
  mr0: d,
  mr1: h,
  mr2: q,
  mr3: z,
  mr4: A,
  mr5: D,
  mr6: E,
  mr7: F,
  mr8: G,
  mr9: H,
  mr10: J,
  mb0: L,
  mb1: M,
  mb2: N,
  mb3: O,
  mb4: P,
  mb5: Q,
  mb6: R,
  mb7: T,
  mb8: U,
  mb9: W,
  mb10: X,
  ml0: Y,
  ml1: Z,
  ml2: __,
  ml3: t_,
  ml4: o_,
  ml5: s_,
  ml6: p_,
  ml7: m_,
  ml8: n_,
  ml9: c_,
  ml10: a_,
  p0: r_,
  p1: l_,
  p2: b_,
  p3: e_,
  p4: i_,
  p5: u_,
  p6: f_,
  p7: g_,
  p8: S_,
  p9: y_,
  p10: v_,
  pt0: x_,
  pt1: C_,
  pt2: V_,
  pt3: $_,
  pt4: j_,
  pt5: k_,
  pt6: w_,
  pt7: B_,
  pt8: I_,
  pt9: K_,
  pt10: d_,
  pr0: h_,
  pr1: q_,
  pr2: z_,
  pr3: A_,
  pr4: D_,
  pr5: E_,
  pr6: F_,
  pr7: G_,
  pr8: H_,
  pr9: J_,
  pr10: L_,
  pb0: M_,
  pb1: N_,
  pb2: O_,
  pb3: P_,
  pb4: Q_,
  pb5: R_,
  pb6: T_,
  pb7: U_,
  pb8: W_,
  pb9: X_,
  pb10: Y_,
  pl0: Z_,
  pl1: _t,
  pl2: tt,
  pl3: ot,
  pl4: st,
  pl5: pt,
  pl6: mt,
  pl7: nt,
  pl8: ct,
  pl9: at,
  pl10: rt
};
function it(_) {
  const t = {};
  if (typeof _ != "object")
    return t;
  for (const o in _) {
    const s = _[o];
    if (c(s, n, m)) {
      const p = `${o}${String(s)}`;
      t[lt[p]] = !0;
    }
  }
  return t;
}
export {
  it as getSpacingClasses
};
//# sourceMappingURL=index.js.map
